export enum ProductCode {
    SERVICE_INVOICE = 'DI_SERVICE_001',
    NO_FRAUD_INVOICE = 'DI_NOID_001',
    ADVANCE_INVOICE = 'AI_001',
}

export default ProductCode;
